import { Text } from '@wartek-id/text-v1'
import { Button } from '@wartek-id/button-v1'
import { Icon } from '@wartek-id/icon-v2'

import { PengelolaanKinerjaTimeline } from 'app/KinerjaShared/components/PengelolaanKinerjaTimeline'
import KinerjaSidebar from 'app/KinerjaShared/components/KinerjaSidebar'
import { assetUrl } from 'utils/url'
import { PENGELOLAAN_KINERJA_GPK_PEJABAT_PENILAI_KINERJA_PATH } from 'app/KinerjaShared/constants/path'
import { PANDUAN_PENGELOLAAN_URL } from 'app/KinerjaShared/utils/panduan'
import useToggleSdkContext from 'utils/useToogleSdk'
import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'
import CardPenilaianPeriodik from 'app/KinerjaShared/components/CardPenilaianPeriodik'
import { useApiGetPenilaianPeriodikTypePS } from 'api/kinerja/pengawas-sekolah/penilaian-periodik'

export function Homepage() {
  const { periodYear } = usePeriodContext()
  const toggleValue = useToggleSdkContext()

  // -------------------------------
  // Resolve penilaian periodik entrypoint
  // --------------------------------
  const isPenilaianPeriodikEnabled =
    toggleValue?.['kinerja-gpk-periodik-enabled'] && periodYear >= 2026

  const {
    data: penilaianPeriodikData,
    isSuccess: isSuccessPenilaianPeriodik,
    isLoading: isLoadingPenilaianPeriodik,
  } = useApiGetPenilaianPeriodikTypePS({
    params: { skpYear: periodYear },
    options: {
      enabled: isPenilaianPeriodikEnabled,
      staleTime: 60 * 60 * 1000,
      cacheTime: 60 * 60 * 1000,
    },
  })

  return (
    <div className="flex w-full min-h-screen">
      <div className="flex-shrink-0 min-h-full">
        <div className="w-64">{/* Sentinel element for sidebar spacing */}</div>
        <KinerjaSidebar activeMenu="gpk-pejabat-penilai-kinerja" sticky />
      </div>
      <div className="w-full gap-4 p-6 space-y-6">
        <section className="shadow-card rounded-lg p-6 bg-white">
          <div className=" flex items-center justify-between gap-6">
            <div className="flex items-center gap-6">
              <img
                alt=""
                src={assetUrl('/images/img-typing-monitor.png')}
                width={84}
                height={84}
                className="flex-shrink-0"
              />
              <div>
                <Text variant="heading-lg" as="h2" className="mb-1">
                  Periksa Perencanaan Kinerja
                </Text>
                <Text color="subdued">
                  Cek Perencanaan yang sudah diajukan oleh Guru Pendidikan
                  Khusus.
                </Text>
              </div>
            </div>
            <Button
              size="lg"
              as="a"
              type={undefined}
              color="black"
              className="min-w-60 whitespace-nowrap"
              href={`${PENGELOLAAN_KINERJA_GPK_PEJABAT_PENILAI_KINERJA_PATH}/perencanaan`}
            >
              Periksa
            </Button>
          </div>

          <div className="rounded bg-cyan-5 p-3 mt-6 flex items-center">
            <Icon color="informational" className="mr-1">
              error
            </Icon>
            Jika satuan pendidikan tidak sesuai, mohon kunjungi&nbsp;
            <a
              className="!text-blue-70 underline"
              href={PANDUAN_PENGELOLAAN_URL}
              target="_blank"
              rel="noreferrer"
            >
              Pusat Bantuan
            </a>
            .
          </div>
        </section>

        {isSuccessPenilaianPeriodik && (
          <CardPenilaianPeriodik
            ctaText="Lakukan"
            isLoading={isLoadingPenilaianPeriodik}
            periodicType={penilaianPeriodikData?.data.periodicType}
            href={`${PENGELOLAAN_KINERJA_GPK_PEJABAT_PENILAI_KINERJA_PATH}/periodik`}
          />
        )}

        <PengelolaanKinerjaTimeline
          timeline={[
            {
              title: 'Januari',
              steps: ['Perencanaan Kinerja'],
            },
            {
              title: 'Februari - November',
              steps: [
                'Persiapan Praktik Kinerja',
                'Pelaksanaan Observasi Praktik Kinerja',
                'Pelaksanaan Tindak Lanjut Praktik Kinerja',
              ],
            },
            {
              title: 'Desember',
              steps: ['Penetapan Predikat Kinerja'],
            },
          ]}
        />
      </div>
    </div>
  )
}
